import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NavParams } from 'ionic-angular';

@Component({
  selector: 'preround-ko-map-game-table',
  templateUrl: 'preround-ko-map-game-table.html',
})
export class PreroundKoGameTablePage {
  gamePlanList: IGamePlan[] = [];

  @Input() plan: any;
  @Input() header: boolean = true;

  @Output() onEdit = new EventEmitter<any>();

  constructor(
    private navParams: NavParams
  ) { }

  onEditTeam(i: number, j: number) {
    this.onEdit.emit({ i: i, j: j, graph: true });
  }
}

export interface IGamePlan {
  id: number;
  gameDay: number;
  name: string;
  team1: {
    id: number;
    name: string;
  };
  team2: {
    id: number;
    name: string;
  }
}






// WEBPACK FOOTER //
// /src/pages/apps/gamer/pages/results/result-pre-round-ko/map-game-table/preround-ko-map-game-table.ts